import { useNewProps } from "./page-props"
import { useTranslation } from "react-i18next"
import { SheetPageBody, SheetPageTitle } from "@/components/ui/sheet-page"
import { ScrollText } from "lucide-react"
import { useNavigate } from "@/lib/page-rendering"
import {
  ShortlistableItemForm,
  ShortlistableItemFormSchema,
} from "@/components/search/shortlists/shortlistable-item-form"

export default function Page() {
  const navigate = useNavigate()
  const { educator_id, shortlists } = useNewProps()
  const { t } = useTranslation(["shortlists", "common"])

  const handleSubmit = (data: ShortlistableItemFormSchema) => {
    const payload =
      data.shortlist._create === "true"
        ? {
            shortlist_attributes: {
              name: data.shortlist.name,
            },
          }
        : {
            shortlist_id: data.shortlist.id,
          }

    navigate({
      href: `/search/educators/${educator_id}/shortlist_entries`,
      method: "post",
      data: { shortlist_entry: payload },
    })
  }

  return (
    <SheetPageBody>
      <SheetPageTitle icon={ScrollText}>
        {t("saved_educators.title")}
      </SheetPageTitle>
      <ShortlistableItemForm
        shortlists={shortlists}
        onSubmit={handleSubmit}
        newLabel={t("saved_educators.form.new_label")}
        newDescription={t("saved_educators.form.new_description")}
        existingLabel={t("saved_educators.form.existing_label")}
        existingDescription={t("saved_educators.form.existing_description")}
        saveLabel={t("common:actions.save")}
      />
    </SheetPageBody>
  )
}
